<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row v-if="props.mode == 'List'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col v-if="props.mode == 'List'" cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col v-if="props.mode == 'List'" cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col v-if="props.mode == 'List'" cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col v-if="props.mode == 'List'" cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
      <!-- <b-col v-if="props.mode == 'List'" cols="12" md="6">
        <InputFilter :filter="search[6]" />
      </b-col>
      <b-col v-if="props.mode == 'List'" cols="12" md="6">
        <InputFilter :filter="search[7]" />
      </b-col> -->
      <b-col v-if="props.mode == 'List'" cols="6">
        <b-form-group label="สถานะ" label-for="clueStatusFilter">
          <vue-select
            label="text"
            v-model="clueStatusFilter"
            :options="statusFilter"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    autoSearch: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const options = [
      { text: "ทั้งหมด", value: null },
      { text: "ใช้งาน", value: true },
      { text: "ไม่ใช้งาน", value: false },
    ];

    const clueStatus = [
      { text: "", value: "" },
      { text: "ส่งต่อหน่วยงานภายใน", value: 9 },
      { text: "ส่งกลับหน่วยงานต้นทาง", value: 18 },
      { text: "ดำเนินการ", value: 124 },
    ];

    const statusFilter = [{ text: "ทั้งหมด", value: null }];

    const searchList = [
      {
        id: "receiveCode",
        label: "เลขแจ้งเบาะแส",
        value: "",
        class: "",
        style: "",
        placeholder: "เลขแจ้งเบาะแส",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ผู้แจ้งเบาะแส",
        value: "",
        class: "",
        style: "",
        placeholder: "ผู้แจ้งเบาะแส",
        type: "text",
        options: [],
      },
      {
        id: "companySearch",
        label: "ผู้ประกอบการ",
        value: "",
        class: "",
        style: "",
        placeholder: "ผู้ประกอบการ",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาที่แจ้งเบาะแส",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "complainDetail",
        label: "รายละเอียดเรื่องแจ้งเบาะแส",
        value: "",
        class: "",
        style: "",
        placeholder: "รายละเอียดเรื่องแจ้งเบาะแส",
        type: "text",
        options: [],
      },
      {
        id: "clueDepartmentId",
        label: "หน่วยงานรับผิดชอบ",
        value: "",
        class: "",
        style: "",
        placeholder: "หน่วยงานรับผิดชอบ",
        type: "text",
        options: [],
      },
      {
        id: "clueStatus",
        label: "สถานะแจ้งเบาะแส",
        value: null,
        class: "",
        style: "",
        placeholder: "สถานะแจ้งเบาะแส",
        type: "bselect",
        options: statusFilter,
      },
    ];

    return {
      options,
      search: searchList,
      statusFilter,
      clueStatusFilter: { text: "ทั้งหมด", value: null },
      props,
    };
  },
  mounted() {
    console.log("autoSearch", this.mode, this.autoSearch);
    if (this.autoSearch === true) {
      this.onSearchBtnClicked();
    }

    this.getClueStatusFilter();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault(e);
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
      this.search[3].value = null;
      this.search[4].value = null;
      this.search[5].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        clueCode: this.search[0].value,
        name: this.search[1].value,
        company: this.search[2].value,
        startDate: this.search[3].value,
        endDate: this.search[4].value,
        clueDetails: this.search[5].value,
        tabName: this.props.mode,
        clueDepartmentId: this.search[6].value,
        statusId:
          this.clueStatusFilter != null ? this.clueStatusFilter.value : null,
      };

      console.log("ค้นหาแจ้งเบาะแส", params);
      this.$emit("handleSubmit", params);
    },
    getClueStatusFilter() {
      const _this = this;
      storeMaster
        .getClueStatusFilter()
        .then(function(response) {
          _this.statusFilter = [
            { text: "ทั้งหมด", value: null },
            ...response.data.data,
          ];
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    selectOnInput() {
      console.log("on input");
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
